import moment from "moment";
import React, { useEffect, useState } from "react";
import { getPublicUrl } from "../../../../helpers/helper_functions";
import { InfoImage } from "./SharedComponents";

import "./InfoBox.css";

function getTotalAnimalDeaths() {
  const animalDeathsPerMs = 1.758; // source: animalclock
  var startYear = moment().year();
  var currentTime = moment().toArray();
  var currentYear = [startYear];

  var cT = moment(currentTime);
  var cY = moment(currentYear);

  return Math.round(cT.diff(cY, "milliseconds") * animalDeathsPerMs);
}

const AnimalDeathInfo = () => {
  const [count, setCount] = useState(getTotalAnimalDeaths());

  // const DivStyle = {
  //   width: "90%",
  //   height: "90%",
  //   marginTop: "2.5%",
  // };

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(getTotalAnimalDeaths());
    }, 55);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="info-box-wrapper left-box">
      <p className="info-text-title">
        {" "}
        <span id="animal-counter">{count.toLocaleString()} </span>
        animals were killed this year in the United States{" "}
      </p>
      <div className="info-text-body">
        <p>
          {" "}
          90 billion animals are killed every year just for sensual pleasure.
          Cows, pigs, chickens, goats, fish, and sheep are subjected to cramped,
          inhumane conditions. Their lives are not shown decency or respect, and
          some animals even have to resort to cannibalism to survive. Either
          way, their lives are ended brutally by the hands that they trusted.{" "}
        </p>
        <p>
          There is NO humane way to kill; an animal's life is worth more than
          your taste buds. Watch{" "}
          <a href="https://www.nationearth.com/earthlings">Earthlings</a> or{" "}
          <a href="https://www.dominionmovement.com/watch">Dominion</a> for more
          details.
        </p>
      </div>
    </div>
  );
};

const AnimalDeathImage = () => {
  return (
    <InfoImage
      className="info-box-image"
      $background_image={getPublicUrl("assets/Home/pigverysadincage.jpg")}
      $background_image_details={"no-repeat 67% 30%"}
    ></InfoImage>
  );
};

export default {
  info: () => <AnimalDeathInfo />,
  image: () => <AnimalDeathImage />,
};
